import React from "react";
const Loader = () => {
    return (
        <>
            <div className="w-full flex flex-col items-center justify-center">
                <img src="../images/loader.gif" className="" alt="Loader" />
            </div>
        </>
    );
};

export default Loader;
